export const pdpEventsConfig = {
    parentSelector: '[id*="MainProduct-template"], .product__description, .product-nav, .sticky-cart-template',
    events: {
        // Product image modal open
        productImageModalOpen: {
            selector: '.product__modal-opener--image',
            event: {
                event: 'pdp',
                component: 'product_image',
                element: 'modal',
                action: 'open',
                trigger: 'click',
                getDynamicData: (element) => {
                    const mediaId = element.closest('[data-media-id]')?.getAttribute('data-media-id');
                    return {
                        media_id: mediaId
                    };
                }
            }
        },

        // Product image modal close
        productImageModalClose: {
            selector: '.pswp__button--close',
            event: {
                event: 'pdp',
                component: 'product_image',
                element: 'modal',
                action: 'close',
                trigger: 'click'
            }
        },

        // Product image navigation (next/previous)
        productImageNavigation: {
            selector: '.product__slider-button',
            event: {
                event: 'pdp',
                component: 'product_image',
                element: 'chevron',
                trigger: 'click',
                getDynamicData: (element) => {
                    const action = element.classList.contains('product__slider-button--next') ? 'next' : 'previous';
                    return {
                        action: action
                    };
                }
            }
        },

        // Product image thumbnail click
        productImageThumbnailClick: {
            selector: '.thumbnail-list__item button',
            event: {
                event: 'pdp',
                component: 'product_image',
                element: 'thumbnail',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const mediaId = element.getAttribute('data-target');
                    return {
                        media_id: mediaId
                    };
                }
            }
        },

        // Product image modal zoom
        productImageModalZoom: {
            selector: '.pswp__button--zoom',
            event: {
                event: 'pdp',
                component: 'product_image_modal',
                element: 'icon',
                field: 'zoom',
                trigger: 'click',
                getDynamicData: (element) => {
                    // Check if the zoom button is in zoom-in or zoom-out state
                    const isZoomIn = element.classList.contains('pswp__button--zoom-in');
                    return {
                        action: isZoomIn ? 'in' : 'out'
                    };
                }
            }
        },

        // Product info link click (tax and description)
        productInfoLinkClick: {
            selector: '.product__tax a, .product__description a, .product__description.rte a',
            event: {
                event: 'pdp',
                component: 'product_information',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    // Determine if the link is from tax or description
                    const isTaxLink = element.closest('.product__tax') !== null;
                    const section = isTaxLink ? 'tax' : 'description';
                    
                    return {
                        section: section,
                        link_text: element.textContent.trim(),
                        link_url: element.href
                    };
                }
            }
        },

        // Product configuration quantity focus
        productConfigQuantityFocus: {
            selector: '.quantity__input',
            event: {
                event: 'pdp',
                component: 'product_configuration',
                element: 'number',
                field: 'quantity',
                action: 'focus',
                trigger: 'focus'
            }
        },

        // Product configuration quantity input
        productConfigQuantityInput: {
            selector: '.quantity__input',
            event: {
                event: 'pdp',
                component: 'product_configuration',
                element: 'number',
                field: 'quantity',
                action: 'input',
                trigger: 'input',
                getDynamicData: (element) => {
                    return {
                        input_value: element.value
                    };
                }
            }
        },

        // Product configuration quantity arrows
        productConfigQuantityArrow: {
            selector: '.quantity__button',
            event: {
                event: 'pdp',
                component: 'product_configuration',
                element: 'chevron',
                field: 'quantity',
                trigger: 'click',
                getDynamicData: (element) => {
                    const action = element.getAttribute('name') === 'plus' ? 'up' : 'down';
                    return {
                        action: action
                    };
                }
            }
        },

        // Product configuration payment link click
        productConfigPaymentLink: {
            selector: '.shopify-payment-button__more-options',
            event: {
                event: 'pdp',
                component: 'product_configuration',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    return {
                        link_text: element.textContent.trim(),
                        link_url: element.href
                    };
                }
            }
        },

        // Product configuration add to cart
        productConfigAddToCart: {
            selector: '.product-form__submit',
            event: {
                event: 'pdp',
                component: 'product_configuration',
                element: 'cta_button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    return {
                        click_text: element.textContent.trim()
                    };
                }
            }
        },

        // Product configuration share
        productConfigShare: {
            selector: '.share-button__button',
            event: {
                event: 'pdp',
                component: 'product_configuration',
                element: 'button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    return {
                        click_text: element.textContent.trim()
                    };
                }
            }
        },

        // Product navigation (next/previous)
        productNavigation: {
            selector: 'a.product-nav__title.full-link.link.h4',
            event: {
                event: 'pdp',
                component: 'product_navigation',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const navItem = element.closest('.product-nav__item');
                    const isNext = navItem.classList.contains('product-nav__item--next');
                    const action = isNext ? 'next' : 'previous';
                    const vendor = navItem.querySelector('.product-nav__vendor')?.textContent.trim();
                    
                    return {
                        action: action,
                        vendor: vendor,
                        link_text: element.textContent.trim(),
                        link_url: element.href
                    };
                }
            }
        },

        // Product navigation chevrons (next/previous)
        productNavigationChevron: {
            selector: '.product-nav__chevron',
            event: {
                event: 'pdp',
                component: 'product_navigation',
                element: 'chevron',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const navItem = element.closest('.product-nav__item');
                    const isNext = navItem.classList.contains('product-nav__item--next');
                    const action = isNext ? 'next' : 'previous';
                    const title = navItem.querySelector('.product-nav__title')?.textContent.trim();
                    const link = navItem.querySelector('.product-nav__title')?.href;
                    
                    return {
                        action: action,
                        link_text: title,
                        link_url: link
                    };
                }
            }
        },

        // Information tabs link click
        informationTabsLink: {
            selector: '.information__value--link',
            event: {
                event: 'pdp',
                component: 'information_tabs',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const tabName = element.closest('.information')?.querySelector('.information__label')?.textContent.trim();
                    return {
                        information_tab: tabName,
                        link_text: element.textContent.trim(),
                        link_url: element.href
                    };
                }
            }
        },

        // Product slider navigation
        productSliderNavigation: {
            selector: '.slider-button',
            event: {
                event: 'pdp',
                component: 'product_slider',
                element: 'chevron',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const fieldName = element.closest('.title')?.querySelector('.title__heading')?.textContent.trim();
                    const action = element.classList.contains('slider-button--next') ? 'next' : 'previous';
                    return {
                        field_name: fieldName,
                        action: action
                    };
                }
            }
        },

        // Product slider card click
        productSliderCard: {
            selector: '.card-wrapper--product',
            event: {
                event: 'pdp',
                component: 'product_slider',
                element: 'card',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const productName = element.querySelector('.card__heading')?.textContent.trim();
                    const link = element.querySelector('.full-unstyled-link');
                    return {
                        product_name: productName,
                        link_url: link?.href
                    };
                }
            }
        },

        // Product slider add to cart
        productSliderAddToCart: {
            selector: '.quick-add__submit',
            event: {
                event: 'pdp',
                component: 'product_slider',
                element: 'cta_button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const productName = element.closest('.card-wrapper--product')?.querySelector('.card__heading')?.textContent.trim();
                    return {
                        product_name: productName,
                        click_text: element.textContent.trim()
                    };
                }
            }
        },

        // Sticky footer add to cart
        stickyFooterAddToCart: {
            selector: 'button.sticky-cart__submit.product-form__submit.button.flex.w100.button--primary.button--medium',
            event: {
                event: 'pdp',
                component: 'sticky_footer',
                element: 'cta_button',
                action: 'click',
                trigger: ['click', 'pointerdown'],
                getDynamicData: (element) => {
                    const productName = element.closest('.sticky-cart-template')?.querySelector('.price--sticky')?.textContent.trim();
                    return {
                        product_name: productName,
                        click_text: element.textContent.trim()
                    };
                }
            }
        }
    }
}; 